<script>
    export let shadow = ''
    $: style = shadow ? `box-shadow: 0 0 ${shadow}px 0 #8c8c8c` : ''
</script>

<div class="component-card component-card-area" {style}>
    <slot />
</div>
